import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppTopbarBrand from '../Layout/AppTopbarBrand';
import PublicHeader from '../Layout/PublicHeader';

/** Dieselbe Handy-Kopfleiste wie News- und Event-Details. */
export default function ChallengeDetailHeader() {
  const navigate = useNavigate();
  return <>
    <div className="hide-mobile"><PublicHeader /></div>
    <div className="app-topbar hide-desktop" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', minHeight: 44 }}>
      <AppTopbarBrand onBack={() => navigate('/winterchallenge')} />
    </div>
  </>;
}
